import React from 'react';

/**
 * Card — the standard white/slate surface used across the app.
 * `hover` adds the lift+shadow interaction used by clickable cards.
 */
export default function Card({
    as: Tag = 'div',
    hover = false,
    padded = true,
    className = '',
    children,
    ...props
}) {
    const classes = [
        'bg-white dark:bg-slate-800 rounded-xl border border-gray-100 dark:border-slate-700 shadow-card',
        hover ? 'transition-all hover:shadow-card-hover hover:-translate-y-1' : '',
        padded ? 'p-6' : '',
        className,
    ].filter(Boolean).join(' ');

    return (
        <Tag className={classes} {...props}>
            {children}
        </Tag>
    );
}
